<p-toast position="bottom-center"></p-toast>
<div class="card">
    <form [formGroup]="settlementForm" novalidate autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="off">

        <div class="card-container bg-gray-100 border-round mt-2 p-4">
            <div class="mr-5 flex align-items-center mb-3">
                <i class="pi pi-file-edit mr-2 text-3xl"></i>
                <div class="font-medium text-3xl text-900">Settlement Request</div>
            </div>

            <div class="grid formgrid p-fluid">

                <div class="field col-12 md:col-6">
                    <app-entity-dropdown-picker
                        formControlName="activityType"
                        [adapter]="activityTypePickerAdapter"
                        inputId="activityType"
                        label="Activity Type"
                        placeholder="Select activity type"
                        filterPlaceholder="Filter activity types"
                        addonIconClass="pi pi-bolt"
                        columnClass="col-12"
                    ></app-entity-dropdown-picker>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input type="text" pInputText formControlName="customerInvoiceNumber" id="customerInvoiceNumber" class="w-full" placeholder="Enter customer invoice number">
                            <label for="customerInvoiceNumber">Customer Invoice Number</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12">
                    <app-entity-dropdown-picker
                        formControlName="promoPlan"
                        [adapter]="promoPlanPickerAdapter"
                        inputId="promoPlan"
                        label="Promo Plans"
                        placeholder="Select a promo plan"
                        filterPlaceholder="Filter promo plans"
                        [showClear]="true"
                        [searchPageSize]="25"
                        [searchMinLength]="0"
                        addonIconClass="pi pi-calendar"
                        columnClass="col-12"
                        (selectionLoaded)="enablePromoFields()"
                    ></app-entity-dropdown-picker>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup class="w-full">
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="startDate" [showIcon]="true" inputId="startDate" class="w-full" [style]="{'width': '100%'}" [appendTo]="'body'"></p-calendar>
                            <label for="startDate">Start Date</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="endDate" [showIcon]="true" inputId="endDate" class="w-full" [appendTo]="'body'"
                                [style]="{'width': '100%'}" [minDate]="settlementForm.get('startDate')?.value"></p-calendar>
                            <label for="endDate">End Date</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup class="w-full">
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="actualStartDate" [showIcon]="true" inputId="actualStartDate" class="w-full" [style]="{'width': '100%'}"></p-calendar>
                            <label for="actualStartDate">Actual Start Date</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="actualEndDate" [showIcon]="true" inputId="actualEndDate" class="w-full" 
                                [style]="{'width': '100%'}" [minDate]="settlementForm.get('actualStartDate')?.value"></p-calendar>
                            <label for="actualEndDate">Actual End Date</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6">
                    <app-entity-dropdown-picker
                        formControlName="customer"
                        [adapter]="customerPickerAdapter"
                        inputId="customer"
                        label="Customer"
                        placeholder="Select a customer"
                        filterPlaceholder="Filter customers"
                        addonIconClass="pi pi-users"
                        columnClass="col-12"
                        (selectionLoaded)="onCustomerSelectionLoaded($event)"
                    ></app-entity-dropdown-picker>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-code"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-dropdown [options]="filteredLocations" formControlName="location" inputId="location" styleClass="w-full" 
                                optionLabel="locationNo" [disabled]="!settlementForm.get('customer')?.value">
                            </p-dropdown>
                            <label for="location">Location</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6">
                    <app-entity-dropdown-picker
                        formControlName="business"
                        [adapter]="businessPickerAdapter"
                        inputId="business"
                        label="Business"
                        placeholder="Select a business"
                        filterPlaceholder="Filter businesses"
                        addonIconClass="pi pi-briefcase"
                        columnClass="col-12"
                    ></app-entity-dropdown-picker>
                </div>

                <div class="field col-12 md:col-6">
                    <app-entity-dropdown-picker
                        formControlName="businessUnit"
                        [adapter]="businessUnitPickerAdapter"
                        inputId="businessUnit"
                        label="Business Unit"
                        placeholder="Select a business unit"
                        filterPlaceholder="Filter business units"
                        addonIconClass="pi pi-briefcase"
                        columnClass="col-12"
                    ></app-entity-dropdown-picker>
                </div>

                
                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-money-bill"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-inputNumber formControlName="value" mode="currency" currency="SAR" inputId="value" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                            <label for="value">Value</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-percentage"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-inputNumber formControlName="vat" mode="currency" currency="SAR" inputId="vat" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                            <label for="vat">VAT</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calculator"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-inputNumber formControlName="totalAmount" mode="currency" currency="SAR" [disabled]="true" inputId="totalAmount" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                            <label for="totalAmount">Total Amount</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-receipt"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-dropdown [options]="[{label: 'Yes', value: true}, {label: 'No', value: false}]" formControlName="serviceInvoice" placeholder="Select Yes/No" inputId="serviceInvoice" styleClass="w-full"></p-dropdown>
                            <label for="serviceInvoice">Service Invoice (Y/N)</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-pencil"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <textarea pInputTextarea formControlName="note" rows="3" class="w-full" inputId="note"></textarea>
                            <label for="note">Note</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
            </div>
        </div>

        <div class="mt-4">
            <p-fieldset legend="Attachments" [toggleable]="true">
                <p-fileUpload 
                    name="attachments[]" 
                    (onSelect)="onFileSelect($event)" 
                    [multiple]="true" 
                    [accept]="attachmentAcceptTypes"
                    [maxFileSize]="maxFileSize"
                    [showUploadButton]="false" 
                    [showCancelButton]="false"
                    [disabled]="isUploadingAttachments"
                    chooseLabel="Choose Files">
                </p-fileUpload>

                <div class="mt-3" *ngIf="isUploadingAttachments">
                    <div class="mb-2 text-600 text-sm">Uploading attachments {{ attachmentUploadProgress }}%</div>
                    <p-progressBar [value]="attachmentUploadProgress"></p-progressBar>
                </div>
                
                <div class="mt-4 grid" *ngIf="attachments.controls.length > 0">
                    <div *ngFor="let control of attachments.controls; let i = index" class="col-12 md:col-6 lg:col-4">
                        <div class="flex align-items-center justify-content-between p-2 border-1 surface-border border-round">
                            <span class="font-medium text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"><i class="pi pi-file mr-2"></i>{{ control.get('fileName')?.value }}</span>
                            <p-button icon="pi pi-times" styleClass="p-button-danger p-button-text p-button-rounded" (click)="removeAttachment(i)"></p-button>
                        </div>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <div class="mt-4" *ngIf="settlementId">
            <p-fieldset legend="System Information" [toggleable]="true" [collapsed]="true" class="mt-6">
                <div class="grid formgrid p-fluid">
                    <div class="field col-12 md:col-6">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-info-circle"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <input type="text" pInputText formControlName="textReference" [disabled]="true" id="textReference" class="w-full">
                                <label for="textReference">Text Reference</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field col-12 md:col-6">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-code"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <input type="text" pInputText formControlName="proposedArGlCode" [disabled]="true" id="proposedArGlCode" class="w-full">
                                <label for="proposedArGlCode">Proposed AR GL Code</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field col-12 md:col-6">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-code"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <input type="text" pInputText formControlName="proposedApGlCode" [disabled]="true" id="proposedApGlCode" class="w-full">
                                <label for="proposedApGlCode">Proposed AP GL Code</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <div class="flex justify-content-end gap-2 m-4 mt-6">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="onCancel()"></p-button>
        <p-button label="Save" icon="pi pi-check" (click)="onSubmit()" [loading]="isSaving || isUploadingAttachments"></p-button>
        </div>
    </form>
</div>
